import {safeCdnImageRef} from 'app/utils/strings';

export function getMediaImageSource(
  imageURL: string | undefined | null,
  mediaURLRead: string,
  size: 'original' | 'small'
) {
  if (!imageURL) {
    return undefined;
  }

  return safeCdnImageRef(imageURL, mediaURLRead, size);
}
